import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/driving-info/DrivingInfoDistance/.eu';
import Kr from '@di-shared/features/history/driving-info/DrivingInfoDistance/.kr';

export interface DrivingInfoDistanceProps {
  vin: string;
  selectedDate: Date;
}

export default function DrivingInfoDistance({vin, selectedDate}: DrivingInfoDistanceProps) {
  return (
    <>
      <Environment.Eu>
        <Eu
          vin={vin}
          selectedDate={selectedDate}
        />
      </Environment.Eu>
      <Environment.Kr>
        <Kr
          vin={vin}
          selectedDate={selectedDate}
        />
      </Environment.Kr>
    </>
  );
}
